import { render, staticRenderFns } from "./itemsRevenueByCategory.vue?vue&type=template&id=9131b38e&scoped=true&"
import script from "./itemsRevenueByCategory.vue?vue&type=script&lang=js&"
export * from "./itemsRevenueByCategory.vue?vue&type=script&lang=js&"
import style0 from "./itemsRevenueByCategory.vue?vue&type=style&index=0&id=9131b38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9131b38e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VBtnToggle,VCard,VCol,VDataTable,VRow,VSelect})
